import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';

// Common for BS journey
import {
  BNK_STMT_getBanks_API_CALL,
  BNK_STMT_getBanks_API_CALL_extrareducer,
} from './bank-statement/api/get-bank';
import {
  BNK_STMT_getPrefferedOptions_API_CALL,
  BNK_STMT_getPrefferedOptions_API_CALL_extrareducer,
} from './bank-statement/api/get-preffered-option';

// Online BS Journey
import {
  BNK_STMT_bsVerifyTxn_API_CALL,
  BNK_STMT_bsVerifyTxn_API_CALL_extrareducer,
} from './bank-statement/api/bs-verify-txn';
import {
  BNK_STMT_perfiosOnlineBanking_API_CALL,
  BNK_STMT_perfiosOnlineBanking_API_CALL_extrareducer,
} from './bank-statement/api/perfios-online-banking';

// Offline BS Journey
import {
  BNK_STMT_s3FileUpload_API_CALL,
  BNK_STMT_s3FileUpload_API_CALL_extrareducer,
} from './bank-statement/api/s3-file-upload';
import {
  BNK_STMT_saveBsDocUpload_API_CALL,
  BNK_STMT_saveBsDocUpload_API_CALL_extrareducer,
} from './bank-statement/api/save-bs-docupload';

import { BNK_STMT_updateCurrentScreenReducer } from './bank-statement/functions/update-current-screen';
import { BNK_STMT_updatePreviousScreenReducer } from './bank-statement/functions/update-previous-screen';
import { BNK_STMT_selectTheBankReducer } from './bank-statement/functions/select-the-bank';
import { BNK_STMT_moveBackConvUIReducer } from './bank-statement/functions/move-back-conv-ui';
import { BNK_STMT_setNoOfStatementReducer } from './bank-statement/functions/set-no-of-statement';
import { BNK_STMT_setBankStatementPasswordReducer } from './bank-statement/functions/set-bank-statement-password';
import { BNK_STMT_flushUploadResponsesReducer } from './bank-statement/functions/flush-upload-responses';
import { BNK_STMT_flushAPICallsDataReducer } from './bank-statement/functions/flush-api-calls-data';
import { BNK_STMT_updateAckScreenMsgsReducer } from './bank-statement/functions/update-ack-screen-msgs';

import InitialStateBsJourney from './bank-statement/api/intial-state-bs-journey';
import { BNK_STMT_comingBackFromPerfiosReducer } from './bank-statement/functions/coming-back-from-perfios';
import { BNK_STMT_setGlobalOverlayLoaderReducer } from './bank-statement/functions/set-global-overlay-loader';
import { BNK_STMT_updateMonthlyStatementErrReducer } from './bank-statement/functions/update-monthly-stmt-err';

import { BNK_STMT_updateJourneyTypeEnumReducer } from './bank-statement/functions/update-journey-type-enum';
import { BNK_STMT_updateFlowTypeEnumReducer } from './bank-statement/functions/update-flow-type-enum';
import { BNK_STMT_updateUserBankReducer } from './bank-statement/functions/user-bank';
import { BNK_STMT_updateRequiredStatementsReducer } from './bank-statement/functions/required-statements';
import { BNK_STMT_updateShowBSWelcomeScreenReducer } from './bank-statement/functions/update-show-welcome-screen';
import { BNK_STMT_updatebsSuccessReducer } from './bank-statement/functions/update-bsSuccess';
import { BNK_STMT_updatebsApprovedReducer } from './bank-statement/functions/update-bsApproved';
import { BNK_STMT_updateNoOfMonthsToShowReducer } from './bank-statement/functions/update-no-of-months-to-show';

export const bankStatementJounrneySlice = createSlice({
  name: 'bankStatementJourney',
  initialState: InitialStateBsJourney,
  reducers: {
    ...BNK_STMT_setNoOfStatementReducer,
    ...BNK_STMT_updateCurrentScreenReducer,
    ...BNK_STMT_selectTheBankReducer,
    ...BNK_STMT_updatePreviousScreenReducer,
    ...BNK_STMT_moveBackConvUIReducer,
    ...BNK_STMT_setBankStatementPasswordReducer,
    ...BNK_STMT_flushUploadResponsesReducer,
    ...BNK_STMT_flushAPICallsDataReducer,
    ...BNK_STMT_updateAckScreenMsgsReducer,
    ...BNK_STMT_comingBackFromPerfiosReducer,
    ...BNK_STMT_setGlobalOverlayLoaderReducer,
    ...BNK_STMT_updateMonthlyStatementErrReducer,
    ...BNK_STMT_updateJourneyTypeEnumReducer,
    ...BNK_STMT_updateFlowTypeEnumReducer,
    ...BNK_STMT_updateUserBankReducer,
    ...BNK_STMT_updateRequiredStatementsReducer,
    ...BNK_STMT_updateShowBSWelcomeScreenReducer,
    ...BNK_STMT_updatebsSuccessReducer,
    ...BNK_STMT_updatebsApprovedReducer,
    ...BNK_STMT_updateNoOfMonthsToShowReducer,
  },
  extraReducers: {
    ...BNK_STMT_getBanks_API_CALL_extrareducer,
    ...BNK_STMT_getPrefferedOptions_API_CALL_extrareducer,
    ...BNK_STMT_bsVerifyTxn_API_CALL_extrareducer,
    ...BNK_STMT_s3FileUpload_API_CALL_extrareducer,
    ...BNK_STMT_saveBsDocUpload_API_CALL_extrareducer,
    ...BNK_STMT_perfiosOnlineBanking_API_CALL_extrareducer,
  },
});

export const {
  BNK_STMT_updateCurrentScreen,
  BNK_STMT_selectTheBank,
  BNK_STMT_updatePreviousScreen,
  BNK_STMT_moveBackConvUI,
  BNK_STMT_setNoOfStatement,
  BNK_STMT_setBankStatementPassword,
  BNK_STMT_flushUploadResponses,
  BNK_STMT_flushAPICallsData,
  BNK_STMT_updateAckScreenMsgs,
  BNK_STMT_comingBackFromPerfios,
  BNK_STMT_setGlobalOverlayLoader,
  BNK_STMT_updateMonthlyStatementErr,
  BNK_STMT_updateFlowTypeEnum,
  BNK_STMT_updateJourneyTypeEnum,
  BNK_STMT_updateRequiredStatements,
  BNK_STMT_updateUserBank,
  BNK_STMT_updateShowBSWelcomeScreen,
  BNK_STMT_updatebsSuccess,
  BNK_STMT_updatebsApproved,
  BNK_STMT_updateNoOfMonthsToShow,
} = bankStatementJounrneySlice.actions;

export function useBankStatementStore() {
  const bankStatementState = useSelector((state) => state.bankStatementJourney);
  const previousScreen = useSelector(
    (state) => state.bankStatementJourney.previousScreen
  );
  const currentScreen = useSelector(
    (state) => state.bankStatementJourney.currentScreen
  );
  const nextScreen = useSelector(
    (state) => state.bankStatementJourney.nextScreen
  );
  const getBankApiInfo = useSelector(
    (state) => state.bankStatementJourney.getBankAPICall
  );
  const journeyTypeEnum = useSelector(
    (state) => state.bankStatementJourney.journeyTypeEnum
  );
  const bsSuccess = useSelector(
    (state) => state.bankStatementJourney.bsSuccess
  );
  const bsApproved = useSelector(
    (state) => state.bankStatementJourney.bsApproved
  );
  const userBank = useSelector((state) => state.bankStatementJourney.userBank);
  const noOfMonthsToShow = useSelector(
    (state) => state.bankStatementJourney.noOfMonthsToShow
  );
  const requiredStatements = useSelector(
    (state) => state.bankStatementJourney.requiredStatements
  );
  const dispatch = useDispatch();
  return {
    // TODO: State returns here
    bankStatementState,
    previousScreen,
    nextScreen,
    bsSuccess,
    bsApproved,
    currentScreen,
    getBankApiInfo,
    journeyTypeEnum,
    userBank,
    requiredStatements,
    noOfMonthsToShow,
    // TODO: Write the sync action functions here
    updateScreen: () => dispatch(BNK_STMT_updateCurrentScreen()),
    selectTheBank: (bankObj) => dispatch(BNK_STMT_selectTheBank(bankObj)),
    updateCurrentScreen: (screenName) =>
      dispatch(BNK_STMT_updateCurrentScreen(screenName)),
    updatePreviousScreen: (screenName) =>
      dispatch(BNK_STMT_updatePreviousScreen(screenName)),
    moveBackConvUI: (screenName) =>
      dispatch(BNK_STMT_moveBackConvUI(screenName)),
    setNoOfStatement: (noOfStatement) =>
      dispatch(BNK_STMT_setNoOfStatement(noOfStatement)),
    setBankStatementPassword: (password) =>
      dispatch(BNK_STMT_setBankStatementPassword(password)),
    flushUploadResponses: (password) =>
      dispatch(BNK_STMT_flushUploadResponses(password)),
    updateJourneyTypeEnum: (payload) =>
      dispatch(BNK_STMT_updateJourneyTypeEnum(payload)),
    updateFlowTypeEnum: (payload) =>
      dispatch(BNK_STMT_updateFlowTypeEnum(payload)),
    updateRequiredStatements: (payload) =>
      dispatch(BNK_STMT_updateRequiredStatements(payload)),
    updateUserBank: (payload) => dispatch(BNK_STMT_updateUserBank(payload)),
    updateShowBSWelcomeScreen: (payload) =>
      dispatch(BNK_STMT_updateShowBSWelcomeScreen(payload)),
    updatebsSuccess: (payload) => dispatch(BNK_STMT_updatebsSuccess(payload)),
    updatebsApproved: (payload) => dispatch(BNK_STMT_updatebsApproved(payload)),
    updateNoOfMonthsToShow: (payload) =>
      dispatch(BNK_STMT_updateNoOfMonthsToShow(payload)),

    // TODO: API calls or Async stuff here
    getBanks_API_CALL: (payload) =>
      dispatch(BNK_STMT_getBanks_API_CALL(payload)),
    getPrefferedOptions_API_CALL: (payload) =>
      dispatch(BNK_STMT_getPrefferedOptions_API_CALL(payload)),

    perfiosOnlineBanking_API_CALL: (payload) =>
      dispatch(BNK_STMT_perfiosOnlineBanking_API_CALL(payload)),
    bsVerifyTxn_API_CALL: (payload) =>
      dispatch(BNK_STMT_bsVerifyTxn_API_CALL(payload)),
    s3FileUpload_API_CALL: (payload) =>
      dispatch(BNK_STMT_s3FileUpload_API_CALL(payload)),
    saveBsDocUpload_API_CALL: (payload) =>
      dispatch(BNK_STMT_saveBsDocUpload_API_CALL(payload)),
    flushAPICallsData: () => dispatch(BNK_STMT_flushAPICallsData()),
    updateAckScreenMsgs: (payload) =>
      dispatch(BNK_STMT_updateAckScreenMsgs(payload)),
    comingBackFromPerfios: (payload) =>
      dispatch(BNK_STMT_comingBackFromPerfios(payload)),
    setGlobalOverlayLoader: (payload) =>
      dispatch(BNK_STMT_setGlobalOverlayLoader(payload)),
    updateMonthlyStatementErr: (payload) =>
      dispatch(BNK_STMT_updateMonthlyStatementErr(payload)),
  };
}

export default bankStatementJounrneySlice.reducer;
